<template>
    <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card color="grey lighten-5">
            <v-flex xs12 sm12>
              <v-toolbar  size="120px" dark color="info">
                <v-toolbar-title >{{dialog_baslik}}</v-toolbar-title>
              </v-toolbar>
            </v-flex>


            <v-card-text>
                <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                <v-layout wrap>
                                       <div class="flex md12">

                    <div v-show="codegorunum === true ">

                      <v-text-field label="Analiz Kodu" v-model="Analiz.AnalysisCode" :error-messages="errors.collect('analizkod')" v-validate="'required'"
                        data-vv-name="analizkod" required> </v-text-field>
                    </div>

                    <v-text-field label="Analiz Adı"  v-model="Analiz.AnalysisName" :error-messages="errors.collect('analizadi')" v-validate="'required'"
                      data-vv-name="analizadi" required> </v-text-field>

                    <v-text-field label="Tutar"  v-model="Analiz.AnalysisAmount"> </v-text-field>

                    <v-text-field label="Analiz Oran %" v-model="Analiz.AnalysisRate"> </v-text-field>
                                       </div>
                </v-layout>
             </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-show="m === true">
                <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
                <v-btn id="bsil" color="blue darken-1" flat @click="deleteanaliz()">Sİl</v-btn>
              </div>
              <div v-show="k === true">
                <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
              </div>
              <v-btn color="blue darken-1" flat @click.native="dialog = false">Vazgeç</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout row wrap>
        <v-toolbar size="120px" dark color="info">
          <v-toolbar-title >Analiz</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
          <v-btn flat @click="analizekle()"> Analiz Ekle
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </v-toolbar>
      </v-layout>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-data-table :headers="headers" :rows-per-page-items=[50,100]  :loading="progress" :items="items" :search="search3">
          <v-progress-linear slot="progress"   indeterminate></v-progress-linear>

          <template slot="items" slot-scope="props">
            <tr @click="Getir(props.item.AnalizKod)" item>
              <td class="text-xs-left">{{ props.item.AnalizKod }}</td>
              <td class="text-xs-left">{{ props.item.AnalizAdi }}</td>
              <td class="text-xs-left">{{ props.item.AnalizTutar }}</td>
              <td class="text-xs-left">{{ props.item.AnalizOran }}</td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
          </v-alert>
        </v-data-table>
      </v-card>
      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Analiz Kodu',
            value: 'AnalizKod'
          },
          {
            text: 'Analiz Adı',
            value: 'AnalizAdi'
          },
          {
            text: 'Analiz Tutarı',
            value: 'AnalizTutar'
          },
          {
            text: 'Analiz Oranı',
            value: 'AnalizOran'
          }
        ],
        items: [],
        search3: '',
        selected: '',
        m: false,
        k: false,
        dialog: false,
        Analiz: {
          AnalysisCode: '',
          AnalysisName: '',
          AnalysisAmount: '',
          AnalysisRate: '',
          CompanyCode:''
        },
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        analizkod: '',
        analizadi: '',
        tutar: '',
        oran: '',
        progress: false,
        dictionary: {
          custom: {
            analizkod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            analizadi: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            tutar: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            oran: {
              required: () => 'Bu alan boş bırakılamaz',
            },
          }
        }
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Analiz Güncelle'
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      CompanyCode:credentials.SirketKodu,
          AnalysisCode: v
        }
        this.$http.post(auth.API_URL + 'api/Analysis/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.Analiz.AnalysisCode = response.body[0].AnalizKod
          this.Analiz.AnalysisName = response.body[0].AnalizAdi
          this.Analiz.AnalysisAmount = response.body[0].AnalizTutar
          this.Analiz.AnalysisRate = response.body[0].AnalizOran
        })
      },
      deleteanaliz: deleteanaliz,
      analizekle: analizekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
  }

  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params1 = {
      CompanyCode:credentials.SirketKodu,
}
this.Analiz.CompanyCode=credentials.SirketKodu
        var params = this.Analiz
        this.$http.post(auth.API_URL + 'api/Analysis/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/Analysis/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
              } else {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
              }
            })
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }

  function analizekle() {
    this.dialog = true
    this.Analiz = {}
    this.dialog_baslik = 'Analiz Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      CompanyCode:credentials.SirketKodu,
}
    this.progress = true
    this.$http.post(auth.API_URL + 'api/Analysis/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.progress = false
      this.items = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function deleteanaliz() {
    if (window.confirm('Analiz\'i silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params1 = {
      CompanyCode:credentials.SirketKodu,
}
this.Analiz.CompanyCode=credentials.SirketKodu
      var params = this.Analiz
      this.$http.post(auth.API_URL + 'api/Analysis/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.$http.post(auth.API_URL + 'api/Analysis/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false
            this.text1 = 'Silme işlemi tamamlandı'
            this.snackbar = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var params = this.Analiz
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Analysis/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = 'Güncelleme işlemi tamamlandı'
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/Analysis/List', {}, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = response.body.ResponseMessage
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>